import React from "react";

export default () => (

    <div className="modal" id="hata_mesaji" tabIndex="-1" data-toggle="modal">
 
      <div className="t-modalAreaStatic" id="id-modalAreaStatic"

      >
        <div className="t-modalContentStatic" id="id-modalTipi"
         style={(window.innerWidth<=900)?{width:"89%"}: {width:"50%"}} >
          <div
            className="t-modalStatic"
            id="id-modalGenelStatic"
            style={{ backgroundColor: "rgb(241, 90, 42)" }}
          >
            <div className="container-fluid" >
              {/* Header */}
              <div className="row t-modalHeaderStatic">
                <div
                  className="col"
                  id="id-modalHeaderStatic"
                  style={{ color: "rgb(255, 221, 221)" }}
                ></div>
                <div className="col-auto t-cursorPointer" data-dismiss="modal" >
                  <i
                    className="t-icon-cross"
                  
                    id="id-modalHeaderIconStatic"
                    style={{ color: "rgb(255, 221, 221)" }}
                  />
                </div>
              </div>
              {/* Body */}
              <div className="row t-modalBodyStatic">
                <div
                  className="col-12"
                  id="id-modalBodyStatic"
                  style={{ color: "rgb(255, 204, 204)" }}
                >
                  <div className="w-100 text-center" style={{ fontSize: "14pt" }}>
                    <i className="t-icon-exclamation" style={{ fontSize: "60pt" }} />
                    <br />
                    <br />
                   
                    <b className="p-4" id="mesaj" style={{ color: "#FFF" }}>
                      Girmiş olduğunuz bilgilerin tamamı veya bir kısmı hatalıdır.
                    </b>
                  </div>
                </div>
              </div>
              {/* footer*/}
              <div className="row t-modalFooter">
                <div
                  className="col-12"
                  id="id-modalFooterStatic"
                  style={{ color: "rgb(255, 187, 187)" }}
                />
              </div>
            </div>
          </div>

        </div>


      </div>
    </div>




);
